import { LabelModel } from '../../models/labels/label.model';
import { ChapterModel } from '../../models/chapter.model';
import { LabelRecipe } from '../../models/labels/label-recipe.enum';

export class Load {
  static readonly type = '[Story Labels] Load';
  constructor() { }
}

export class LoadSuccess {
  static readonly type = '[Story Labels] Load Success';
  constructor(public result: string) { }
}

export class SetLabels {
  static readonly type = '[Story Labels] Set Labels';
  constructor(public labels: LabelModel[]) { }
}

export class AddLabel {
  static readonly type = '[Story Labels] Add Label';
  constructor(public label: LabelModel) { }
}

export class AddContextLabel {
  static readonly type = '[Story Labels] Set Contexdt Label';
  constructor(public label: LabelModel) { }
}

export class CopyLabels {
  static readonly type = '[Story Labels] Copy Labels';
  constructor(public sourceChapter: ChapterModel, public targetChapter: ChapterModel) { }
}

export class RemoveLabel {
  static readonly type = '[Story Labels] Remove Label';
  constructor(public label: LabelModel) { }
}

export class RemoveContextLabel {
  static readonly type = '[Story Labels] Remove Context Label';
  constructor() { }
}

export class RemoveAllLabels {
  static readonly type = '[Story Labels] Remove All Labels';
  constructor() { }
}

export class RemoveAllChapterLabels {
  static readonly type = '[Story Labels] Remove All Chapter Labels';
  constructor(public chapter: ChapterModel) { }
}

export class SetLabel {
  static readonly type = '[Story Labels] Set Label';
  constructor(public label: LabelModel) { }  
}

export class SelectLabel {
  static readonly type = '[Story Labels] Select Label';
  constructor(public label?: LabelModel) { }
}

export class ResetLabels {
  static readonly type = '[Story Labels] Reset';
  constructor() { }
}

export class ConvertLabels {
  static readonly type = '[Story Labels] Convert';
  constructor(public labels: LabelModel[], public type: LabelRecipe) { }
}

export class EnableContextLabel {
  static readonly type = '[Story Labels] Enable Context Label';
  constructor(public enable: boolean) { }
}

